export default "__VITE_ASSET__C4ovLto6__"